import { IDocumentFileModel } from '@api/models';
import { addUserToDocument } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface AddUserToDocumentOptions {
    clientId: string;
    file: IDocumentFileModel;
    folderId: string;
}

const useAddUserToDocumentForm = (options: AddUserToDocumentOptions) => {
    const { file, folderId, clientId } = options;

    const addUserToDocumentMutation = useMutation((userIds: string[]) =>
        addUserToDocument(clientId, file._id, userIds, folderId)
    );

    const submit = async (value: string[]) => {
        await addUserToDocumentMutation.mutateAsync(value);
    };

    return {
        isLoading: addUserToDocumentMutation.isPending,
        submit,
    };
};

export default useAddUserToDocumentForm;
